import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { TransferWorkshopStoreModel } from 'src/app/models/maintenance/transfer-workshop-store.model';
import { TransferWorkshopStorePrintModel } from 'src/app/models/print/maintenance/transfer-workshop-store-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransferWorkshopStoreService {

  constructor(private _httpClient: HttpClient) { }

  annulAsync(transferWorkshopStoreId: number): Observable<TransferWorkshopStoreModel> {
    return this._httpClient.put<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.AnnulAsync}/${transferWorkshopStoreId}`,
      null);
  }

  blockAsync(transferWorkshopStoreId: number): Observable<TransferWorkshopStoreModel> {
    return this._httpClient.put<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.BlockAsync}/${transferWorkshopStoreId}`,
      null)
  }

  changeStateAsync(transferWorkshopStoreId: number): Observable<TransferWorkshopStoreModel> {
    return this._httpClient.put<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.ChangeStateAsync}/${transferWorkshopStoreId}`,
      null);
  }

  createAsync(TransferWorkshopStoreModel: TransferWorkshopStoreModel): Observable<TransferWorkshopStoreModel> {
    return this._httpClient.post<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.CreateAsync}`,
      TransferWorkshopStoreModel);
  }

  deleteAsync(transferWorkshopStoreId: number): Observable<TransferWorkshopStoreModel> {
    return this._httpClient.delete<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.DeleteAsync}/${transferWorkshopStoreId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllTransferWorkshopStoresWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.GetAllTransferWorkshopStoresWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getByIdAsync(transferWorkshopStoreId: number): Observable<TransferWorkshopStoreModel> {
    return this._httpClient.get<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.GetByIdAsync}/${transferWorkshopStoreId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstTransferWorkshopStoreByKeysAsync(branchId: number): Observable<TransferWorkshopStoreModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.GetFirstTransferWorkshopStoreByKeysAsync}`,
      { params: params });
  }

  getEmptyTransferWorkshopStorePrint(): Observable<TransferWorkshopStorePrintModel> {
    return this._httpClient.get<TransferWorkshopStorePrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.GetEmptyTransferWorkshopStorePrint}`);
  }

  getLastTransferWorkshopStoreByKeysAsync(branchId: number): Observable<TransferWorkshopStoreModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.GetLastTransferWorkshopStoreByKeysAsync}`,
      { params: params });
  }

  getNextTransferWorkshopStoreByKeysAsync(branchId: number, consecutive: number): Observable<TransferWorkshopStoreModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.GetNextTransferWorkshopStoreByKeysAsync}`,
      { params: params });
  }

  getPermissionPrintAsync(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.GetPermissionPrintAsync}`);
  }

  getPreviusTransferWorkshopStoreByKeysAsync(branchId: number, consecutive: number): Observable<TransferWorkshopStoreModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.GetPreviusTransferWorkshopStoreByKeysAsync}`,
      { params: params });
  }

  getTransferWorkshopStoreByKeysByPrint(branchId: number, consecutive: number, transferWorkshopStoreId: number): Observable<TransferWorkshopStorePrintModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive).set('transferWorkshopStoreId', transferWorkshopStoreId);
    return this._httpClient.get<TransferWorkshopStorePrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.GetTransferWorkshopStoreByKeysByPrintAsync}`,
      { params }
    );
  }

  getTransferWorkshopStoreByKeysAsync(branchId: number, consecutive: number): Observable<TransferWorkshopStoreModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.GetTransferWorkshopStoreByKeysAsync}`,
      { params: params });
  }

  hasExistingTransferWorkshopStore(branchId: number): Observable<boolean> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.HasExistingTransferWorkshopStoreAsync}`,
      { params: params }
    );
  }

  updateAsync(transferWorkshopStoreContract: TransferWorkshopStoreModel): Observable<TransferWorkshopStoreModel> {
    return this._httpClient.put<TransferWorkshopStoreModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStore.UpdateAsync}`,
      transferWorkshopStoreContract);
  }
}
